import React from "react";
import FadeIn from "../components/FadeIn";

export default function AIKnowledge({ lang, t }) {
  const scrabbleImage = "https://assets.auxodev.dk/assets/25c88f45-a091-4778-ada1-e41c6b1f66ac/scrabble-news-ai.jpg";

  return (
    <section id="ai-knowledge" className="relative w-full min-h-screen bg-zinc-100 font-sans py-16 md:py-24 px-6 md:px-12 flex flex-col justify-center border-b border-zinc-200">
      <FadeIn className="max-w-6xl mx-auto w-full space-y-6 md:space-y-8 my-auto">
        {/* Main Header */}
        <div className="space-y-2">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-brand-navy tracking-tight font-display">
            {t("aiKnowledge.title")}
          </h2>
          <div className="h-1 w-16 bg-brand-orange"></div>
          <p className="text-sm md:text-base text-brand-orange font-medium uppercase tracking-wide">
            {t("aiKnowledge.subtitle")}
          </p>
        </div>

        {/* Two-Column Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          {/* Left Column: Image with Accent Border */}
          <div className="lg:col-span-4 flex justify-center lg:justify-start">
            <div className="border border-zinc-200 inline-block overflow-hidden shadow-sm bg-white p-1.5 w-full max-w-[380px]">
              <img
                src={`https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/${scrabbleImage.replace("https://assets.auxodev.dk/", "")}`}
                alt="Scrabble bogstaver der staver NEWS og AI"
                width="380"
                height="260"
                loading="lazy"
                className="w-full object-cover block transition-transform duration-500 hover:scale-105"
              />
            </div>
          </div>

          {/* Right Column: Content Box */}
          <div className="lg:col-span-8 bg-white border border-zinc-200 p-6 md:p-8 shadow-sm relative">
            <div className="absolute top-0 left-0 w-1.5 h-full bg-brand-blue"></div>
            <p className="text-zinc-600 text-sm md:text-base leading-relaxed font-light mb-6 border-b border-zinc-100 pb-4">
              {t("aiKnowledge.intro")}
            </p>

            <div className="space-y-6">
              <div className="border-l-4 border-brand-blue pl-4">
                <h3 className="font-bold text-brand-navy text-sm uppercase tracking-wider font-display">
                  {t("aiKnowledge.challengeTitle")}
                </h3>
                <p className="text-zinc-500 text-xs md:text-sm font-light mt-1 leading-relaxed">
                  {t("aiKnowledge.challengeText")}
                </p>
              </div>

              <div className="border-l-4 border-brand-green pl-4">
                <h3 className="font-bold text-brand-navy text-sm uppercase tracking-wider font-display">
                  {t("aiKnowledge.solutionTitle")}
                </h3>
                <p className="text-zinc-500 text-xs md:text-sm font-light mt-1 leading-relaxed">
                  {t("aiKnowledge.solutionText")}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Benefits Grid */}
        <div className="space-y-4 border-t border-zinc-200 pt-6">
          <h3 className="text-xl md:text-2xl font-bold text-brand-navy tracking-tight font-display">
            {lang === "en" ? "Key Benefits of Our AI Platforms" : "Nøglefordele ved Vores AI-Platforme"}
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {t("aiKnowledge.benefits").map((benefit, idx) => (
              <div
                key={idx}
                className="bg-white border border-zinc-200 p-5 shadow-sm rounded-none flex flex-col gap-3 hover:shadow-md transition-all duration-300 relative overflow-hidden group"
              >
                <div className="absolute top-0 left-0 w-full h-1 bg-brand-navy group-hover:bg-brand-orange transition-colors duration-300"></div>
                <div className="flex items-center gap-3">
                  <div className="h-8 w-8 bg-brand-navy text-white flex items-center justify-center font-bold text-xs font-display">
                    0{idx + 1}
                  </div>
                  <h4 className="font-bold text-brand-navy text-sm font-display">{benefit.title}</h4>
                </div>
                <p className="text-zinc-500 text-xs font-light leading-relaxed">
                  {benefit.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* What Makes Our Solution Different Panel */}
        <div className="space-y-4">
          <h3 className="text-xl md:text-2xl font-bold text-brand-navy tracking-tight font-display">
            {t("newalbert.differentTitle")}
          </h3>

          <div className="border-l-4 border-brand-orange bg-white rounded-none p-6 md:p-8 shadow-sm relative">
            <p className="text-sm md:text-base font-light text-zinc-600 leading-relaxed">
              <span className="font-bold italic text-[#10b981] font-display text-base block mb-2">NewAlbert</span>{" "}
              {t("newalbert.differentText").replace("NewAlbert", "")}
            </p>
          </div>
        </div>
      </FadeIn>
    </section>
  );
}
